import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './context/ThemeContext';
import { AppRouter } from './AppRouter';
render(<HelmetProvider data-id="element-1246">
    <ThemeProvider data-id="element-1247">
      <AppRouter data-id="element-1248" />
    </ThemeProvider>
  </HelmetProvider>, document.getElementById('root'));